import { call, put, takeLatest, select } from 'redux-saga/effects';

import * as Routines from '../Routines';
import { feedbackFailure } from '../../../Feedback/reducer';
import * as Api from '../api';
import { AppAction, AppData } from '../../../Store/types';
import { mapDeviceTypes, updateDeviceAndModifiedTime } from '../../utils';
import { selectAppData, selectIsPartner, selectIsPrivate } from '@Safemate/Store/selectors';
import { IDevice, IPartnerDevice } from '@Safemate/Model/Device';
import { getFilters } from '../selectors';
import { DeviceSimpleSensor, FilterState, SimpleSensor } from '../types';
import { DeviceListActionTypes } from '../actionTypes';
import { loadFilters, PersistedFilters } from '../utils';
import { setFilters } from '../actions';

function* initialize(action: AppAction<null>){
  try {

    
    const appData: AppData = yield select(selectAppData);
    const roleId = appData.activeRoles.length > 0 ? appData.activeRoles[0].id : 0;
    const userId = appData.user.id;
    const loadedFilters: PersistedFilters = loadFilters(roleId, userId);

    yield put(setFilters(loadedFilters));

    const isPrivate: boolean = yield select(selectIsPrivate);
    const isPartner: boolean = yield select(selectIsPartner);
    const filters: FilterState = yield select(getFilters);

    const devices: IDevice[] = yield call(Api.getDevices, 0, 0, filters.wifiFilter, isPrivate);

    const { alarms, lastModifiedTime } = updateDeviceAndModifiedTime(devices, 0);

    for(const alarmDevice of alarms){
        yield put(Routines.alarmAnalysis(alarmDevice.deviId));
    }

    yield put(Routines.twinSuffix());

    const deviceTypes = mapDeviceTypes(devices);

    if(isPartner){
      const partnerDevices: IPartnerDevice[] = yield call(Api.getPartnerDeviceList);
      yield put(Routines.partnerDeviceList.success(partnerDevices));
    }

    yield put(Routines.initialize.success({devices, deviceTypes, lastModifiedTime}));

  }
  catch(e){
    if(e.response.status !== 403){
      yield feedbackFailure(e);
    }
    yield put(Routines.initialize.failure());
  }
  yield put(Routines.initialize.fulfill());
}

function* twinSuffix(action: AppAction<null>){
  try{
    const suffix: string = yield call(Api.getTwinSuffix);
    yield put(Routines.twinSuffix.success(suffix));
  }
  catch(e){
    yield put(Routines.twinSuffix.failure());
  }
}

function* sensorsForUser(action: AppAction<null>){
  try{
    const sensors: DeviceSimpleSensor = yield call(Api.getSensorsForUser);
    yield put(Routines.getSensorsForUser.success(sensors));
  }
  catch(e){
    yield put(Routines.getSensorsForUser.failure());
  }
}

function* initializationSaga(){
    yield takeLatest(Routines.initialize.TRIGGER, initialize);
    yield takeLatest(Routines.initialize.SUCCESS, sensorsForUser);
    yield takeLatest(DeviceListActionTypes.TOGGLE_WIFI_FILTER, initialize);
    yield takeLatest(Routines.twinSuffix.TRIGGER, twinSuffix);
}

export default initializationSaga;
